import Joi from 'joi';
import { AxiosError } from 'axios';
import api from '../api';

/**
 * Get user admin List
 * @param {object} queryParams - The query parameters.
 * @returns {Promise<
 * {total: number, pageNumber: number, data: User[]}>} - The list of customers.
 */
export const getUsers = async (queryParams) => {
  // remove empty queryParams
  const cleanQueryParams = queryParams;
  Object.keys(cleanQueryParams).forEach(
    /**
     * @param {keyof typeof queryParams} key
     * @returns {void} - remove empty queryParams
     */
    (key) => {
      if (!cleanQueryParams[key]) {
        delete cleanQueryParams[key];
      }
    },
  );
  const result = await api.get('/users', { params: cleanQueryParams });

  try {
    const schema = Joi.object({
      total: Joi.number().required(),
      pageNumber: Joi.number().required(),
      data: Joi.array().items(
        Joi.object({
          id: Joi.number().required(),
          firstname: Joi.string().required(),
          lastname: Joi.string().required(),
          email: Joi.string().required(),
          role: Joi.string().required(),
          createdAt: Joi.string().required(),
        }),
      ),
    }).required();
    await schema.validateAsync(result.data, { allowUnknown: true });
  } catch (/** @type {any} */ error) {
    throw new AxiosError('', `API response do not match User list Schema : ${error.message}`);
  }

  return result.data;
};
